import React from 'react'
import styled from 'styled-components';
import { transparentize } from 'polished'

import { formatMoney } from "~/utils/money";

const PriceBoxContainer = styled.div`
  background: ${props => transparentize(0.9, props.theme.primary)};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-weight: bold; 
  font-size: ${props => (props.largePriceBox ? '24px' : '14px')};
  color: ${props => (props.hasComparePrice ? props.theme.discount : props.theme.primary)};
  text-align: center;
  line-height: ${props => (props.largePriceBox ? '28px' : '24px')};
  padding: 12px 5px;
  background: ${props => (props.theme.background)};
`;
const Price = styled.div``;
const ComparePrice = styled.div`
  text-decoration: line-through;
  font-size: 0.85em;
  line-height: 1.5;
  color: ${props => props.theme.primary};
`;


export default class PriceBox extends React.PureComponent {
  hasComparePrice = () => {
    const { product, failed, largePriceBox, style } = this.props;

    return product.compare_price && (product.price.amount < product.compare_price.amount);
  }

  render() {
    const { product, failed, largePriceBox, style } = this.props;

    return (
      <PriceBoxContainer hasComparePrice={ this.hasComparePrice() } largePriceBox={ largePriceBox }>
        <Price>{ formatMoney(product.price, true) }</Price>
        { this.hasComparePrice() ? <ComparePrice>{ formatMoney(product.compare_price, true) }</ComparePrice> : null }
      </PriceBoxContainer>
    )
  }
}